import _ from 'lodash';
import { defineUserStore } from '@/stores/user';

export const getLabel = (list: any, val: string | number) => {
    const target = list.find((i: any) => i.value === val);
    let labelName = "--";
    if (target) {
        labelName = target['label'];
    }
    return labelName;
}

export const renderDefaultValue = (value: any) => {
    return typeof value === 'number' ? value : (value || '--');
}



type OriginalFormKey = {
    prop: string;
    baseType: string;
    title: string;
    type: string;
    label: string;
    placeholder?: string;
    needTranslate?: boolean;
    suffix?: string;
    labelProp?: string;
    disabled?: boolean;
    [key: string]: any
};
type GroupedFormKey = {
    baseType: string;
    title: string;
    list: Array<Pick<OriginalFormKey, 'prop' | 'type' | 'label' | 'placeholder'>>;
};
export const transformFormKeys = (originalKeys: OriginalFormKey[]): GroupedFormKey[] => {
    const groupedKeys: Record<string, GroupedFormKey> = {};
    originalKeys.forEach((key) => {
        if (!groupedKeys[key.baseType]) {
            groupedKeys[key.baseType] = {
                baseType: key.baseType,
                title: key.title,
                list: []
            };
        }
        groupedKeys[key.baseType].list.push(key);
    });
    return Object.values(groupedKeys);
}

export const getFloatNumber = (num: any, n = 2) => {
    if (!num || num === 'inf' || num === 'inf%') return num;
    return parseFloat(Number(num).toFixed(n));
};

export const thousandSeparator = function (n: any) {
    if (!n || n === 'inf' || n === 'inf%') return n;
    let str = n + '';
    let suffix = '';
    let prefix = '';
    if (str[str.length - 1] === '%') {
        suffix = '%';
        str = str.substring(0, str.length - 1);
    }
    if (str[0] === '$') {
        prefix = '$';
        str = str.substring(1, str.length);
    }

    const arr = str.split('.');
    const res = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (arr[1]) {
        return prefix + res + '.' + arr[1] + suffix;
    }
    return prefix + res + suffix;
};

export const handleTrendDataToArr = (value: string) => {
    const valueArr = value.split(',');
    const dateArr: string[] = [];
    const dataArr: number[] = [];
    valueArr.forEach((item) => {
        const arr = item.split('_');
        dateArr.push(arr[0]);
        dataArr.push(parseInt(arr[1]));
    });
    return { dateArr, dataArr };
};
export const getAllIndicatorLabelNames = (targetData: any) => {
    const labelList: Array<string> = [];
    _.forEach(targetData, (item: any) => {
        labelList.push(item && (item.label));
    })
    return labelList;
}

// 用于计算和设置table列宽的函数
export const setColumnWidth = (columnLabel: string) => {
    const canvas: any = document.createElement('canvas');
    const context: any = canvas.getContext('2d');
    // 英文状态下，特殊处理，避免过长
    const frontendThreeWordWidth = _.join(_.slice(_.split(columnLabel, " "), 0, 3), " ");
    const width: number = context.measureText(frontendThreeWordWidth).width;
    return width + 70;
}

// 获取聚合维度默认值
export const getTagDefaultValue = (type: number) => {
    switch (type) {
        case 1:
            return [
                { label: 'analysis.leadLevel', value: 'customer_source' },
            ];
        case 2:
            return [
                { label: 'analysis.clientLevel', value: 'customer_source' },
            ];
        case 3:
            return [
                { label: 'common.businessLine', value: 'business' },
            ];
        case 4:
            return [
                { label: 'analysis.moduleLevel', value: 'module' },
            ];
        case 5:
            return [
                { label: 'common.clientLevel', value: 'customer_level' }
            ];
        case 6:
            return [
                { label: 'common.industry', value: 'industry' }
            ];
        case 7:
            return [];
    }
}
export const renderCityStr = (row: any, t: Function) => {
    const country = row.country_str || '';
    const province = row.province_str || '';
    const city = row.city_str || '';
    const area = row.area_str || '';
    if (country === '' && province === '' && city === '' && area === '') {
        return '--';
    }
    if (t('btn.Cancel') === 'Cancel') {
        return area + (area !== '' ? ',' : '') + city + (city !== '' ? ',' : '') + province + ((province !== '' && country !== '') ? ',' : '') + country;
    }
    return country + ' ' + province + ' ' + city + ' ' + area;
}

export const formatFilterTag = (key: string, type: string, unit: string | undefined, value: any) => {
    let text = '';
    let formatValue: Array<string> = value;

    if (unit === '$') {
        formatValue = _.map(value, (item) => `$${item}`);
    } else if (unit === '%') {
        formatValue = _.map(value, (item) => `${item}%`);
    }

    if (_.isEmpty(value)) {
        text = '';
    } else if (type === '>=' || type === '<=') {
        text = `${key} ${type} ${formatValue}`;
    } else if (type === 'between') {
        text = `${key} ${type} [${formatValue}]`;
    } else {
        //excluded
        text = `${key} ${type} [${formatValue}]`;
    }
    return text;
};

export const getSearchScopeAndOwner_id = (val: any, underList: any) => {
    // 1. 勾选本人 和 全选下属  scope  传 1 owner_id 不用传
    // 2. 勾选 本人  scope =2  owner_id  为空
    // 3. 勾选 本人 和 部分下属 scope = 4 owner_id 传勾选值 以及额外获取当前用户的id 拼接上
    // 4. 勾选 全部下属 scope =3 owner_id 为空
    // 5. 勾选 部分下属 scope = 4  owner_id 为 勾选的id集合
    let scope = 0;
    let owner_id = '';

    const underlingTotalNum = underList.length;
    const allSelectedType = [];
    const allSelectedItem = [];

    // 获取当前用户信息Owner_id
    const userStore = defineUserStore();
    const myselfOwner_id = userStore.User && userStore.User.base_info && userStore.User.base_info.user_id;

    _.forEach(val, (item) => {
        allSelectedType.push(item[0]);
        if (item[1] != undefined) {
            allSelectedItem.push(item[1]);
        }
    });
    if (allSelectedType.includes('myself')) {
        if (allSelectedItem.length === underlingTotalNum) {
            scope = 1;
            owner_id = '';
        } else if (allSelectedItem.length === 0) {
            scope = 2;
            owner_id = '';
        } else if (allSelectedItem.length < underlingTotalNum) {
            scope = 4;
            owner_id = `${myselfOwner_id},` + allSelectedItem.join(',');
        }
    } else {
        if (allSelectedItem.length != 0 && allSelectedItem.length === underlingTotalNum) {
            scope = 3;
            owner_id = '';
        } else if (allSelectedItem.length > 0) {
            scope = 4;
            owner_id = allSelectedItem.join(',');
        } else {
            scope = 0;
            owner_id = '';
        }
    }

    return { scope, owner_id };
};

export const cascaderFilterFunc = (node, val) => {
    if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
        return true;
    }
};

export const exportDownExcel = (data: any) => {
    const { filename, url } = data;
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
